exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.empty-state[data-v-6be5c724] {\n  text-align: center;\n  font-size: 24px;\n  margin-top: 100px;\n  color: #ccc;\n}\n.empty-state .icon[data-v-6be5c724] {\n    font-size: 48px;\n}\n.categories[data-v-6be5c724] {\n  margin: 20px 0;\n}\n.category[data-v-6be5c724] {\n  display: block;\n  padding: 15px 20px;\n  margin-bottom: 5px;\n  text-transform: uppercase;\n  background-color: #ff7850;\n  color: #fff;\n  cursor: pointer;\n}\n.category i[data-v-6be5c724] {\n    float: right;\n    font-size: 16px;\n    margin-top: -4px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6be5c724","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Categories.vue
// module id = 49
// module chunks = 0